import Image from 'next/image'
import { useEffect } from 'react'
import type { Marble } from 'src/types/domain/Marble'

type Props = Readonly<{
  marble: Pick<Marble, 'number' | 'image'>
  tooltip?: string
  className?: string
}>

export function MarbleItem({ marble, tooltip, className }: Props) {
  useEffect(() => {
    if (marble.image) {
      const img = new window.Image()
      img.src = marble.image
    }
  }, [marble.image])

  return (
    <div
      className={`marble ${tooltip ? '' : 'no-tooltip'} marble-xs active ${className}`}
      data-tooltip={tooltip}
    >
      {marble.image ? (
        <Image
          alt=""
          className="marble-background-image"
          draggable="false"
          fill
          priority
          sizes="60px"
          src={marble.image}
        />
      ) : null}
    </div>
  )
}
